<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="row">
        <div class="col-xs-6">
          <h1>Add Banner</h1>
        </div>
        <div class="col-xs-6 mandatoryDiv">
          <span class="mandatory_color">(*)</span>
          <span class="letter-right"> Marked are required field</span>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-12">
          <div class="alert alert-info" v-if="alert_message">
            {{ alert_message }}
          </div>
        </div>
        <form @submit.prevent="formSubmit" ref="myForm">
          <div class="col-sm-12">
            <div class="box">
              <div class="box-header">
                <h3 class="box-title">Add Information</h3>
              </div>
              <div class="box-body form-box-body form-horizontal">
                <div class="form-group">
                  <label class="col-md-2 control-label">
                    Offer Slider Name
                    <span class="mandatory_horizontal">*</span>
                  </label>
                  <div class="col-md-10">
                    <input
                      type="text"
                      v-model="formData.banner_name"
                      id="banner_name"
                      name="banner_name"
                      placeholder="Enter Name of Banner"
                      required
                      maxlength="255"
                      class="form-control input-sm"
                      @focus="$event.target.removeAttribute('readonly')"
                      @input="errors.banner_name && delete errors.banner_name"
                      readonly
                    />
                    <small v-if="errors.banner_name" class="text-danger">{{
                      errors.banner_name
                    }}</small>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">
                    Subscription Type
                    <span
                      class="glyphicon glyphicon-info-sign text-info"
                      data-toggle="tooltip"
                      title="To apply all resellers pins except symlexvpn, select Filter Reseller PIN, Reseller online pin will match with Online Free and Premium filter"
                    ></span>
                  </label>
                  <div class="col-md-10">
                    <v-select
                      v-model="formData.user_type"
                      :options="[
                        { value: '1', text: 'Reseller PIN(Offline)' },
                        { value: '2', text: 'Online Premium' },
                        { value: '3', text: 'Online Free' },
                      ]"
                      label="text"
                      :reduce="(option) => option.value"
                      multiple
                      placeholder="Any Type Of Subscribers"
                      @input="checkUserTypeSelection"
                      class="input-sm"
                    ></v-select>
                    <small v-if="errors.user_type" class="text-danger">{{
                      errors.user_type
                    }}</small>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">
                    Website Banner (Offer Page Image)
                  </label>
                  <div class="col-md-4">
                    <input
                      type="text"
                      :disabled="formData.id ? true : false"
                      v-model="formData.website_img"
                      id="website_img"
                      name="website_img"
                      placeholder="Enter Image Src URL"
                      class="form-control input-sm"
                      @focus="$event.target.removeAttribute('readonly')"
                      readonly
                    />
                  </div>
                  <label class="col-md-2 control-label"
                    >Website Img Onclick URL</label
                  >
                  <div class="col-md-4">
                    <input
                      type="text"
                      :disabled="formData.id ? true : false"
                      v-model="formData.website_img_click_link"
                      id="website_img_click_link"
                      name="website_img_click_link"
                      placeholder="Enter Destination URL"
                      class="form-control input-sm"
                      @focus="$event.target.removeAttribute('readonly')"
                      readonly
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-2 control-label">
                    Login Country Selection Type
                  </label>
                  <div class="col-md-4">
                    <v-select
                      v-model="formData.country_selection_type"
                      :options="[
                        { value: 1, text: 'Include Countries' },
                        { value: 2, text: 'Exclude Countries' },
                      ]"
                      label="text"
                      :reduce="(option) => option.value"
                      placeholder="No Country Selected"
                      @input="checkCountrySelect"
                      class="input-sm"
                    ></v-select>
                  </div>

                  <label class="col-md-2 control-label country-label">
                    <span id="countryFilterTypeText">{{
                      countryFilterTypeText
                    }}</span>
                    Country
                  </label>
                  <div class="col-md-4">
                    <v-select
                      v-model="formData.specific_countries"
                      :options="countries"
                      label="name"
                      :reduce="(option) => option.code"
                      multiple
                      placeholder="All Countries Will Get The Offer"
                      @input="checkCountryTypeRequired"
                      class="input-sm"
                    ></v-select>
                    <small
                      v-if="errors.specific_countries"
                      class="text-danger"
                      >{{ errors.specific_countries }}</small
                    >
                  </div>
                </div>

                <!-- <div class="form-group">
                  <label class="col-md-2 control-label"
                    >Trial(Premium) Selection</label
                  >
                  <div class="col-md-4">
                    <v-select
                      v-model="formData.trial_selection_type"
                      :options="[
                        { value: '', text: 'No Trial Filter' },
                        { value: '1', text: 'Include' },
                        { value: '2', text: 'Exclude' },
                      ]"
                      label="text"
                      :reduce="(option) => option.value"
                      placeholder="No Trial Filter"
                      @input="checkTrialSelect"
                      class="input-sm"
                    ></v-select>
                  </div>

                  <label class="col-md-2 control-label trial-babel">
                    <span id="trialFilterTypeText">{{
                      trialFilterTypeText
                    }}</span>
                    Trial Type
                  </label>
                  <div class="col-md-4">
                    <v-select
                      v-model="formData.trial_type"
                      :options="[
                        { value: '1', text: 'Trialling' },
                        { value: '2', text: 'Trialled (Not Purchased)' },
                      ]"
                      label="text"
                      :reduce="(option) => option.value"
                      multiple
                      placeholder="Not Specified"
                      @input="checkTrialSelectionRequired"
                      class="input-sm"
                    ></v-select>
                    <small v-if="errors.trial_type" class="text-danger">{{
                      errors.trial_type
                    }}</small>
                  </div>
                </div> -->

                <div class="form-group">
                  <label class="col-md-2 control-label"
                    >Subscription Status</label
                  >
                  <div class="col-md-4">
                    <v-select
                      v-model="formData.subscription_status"
                      :options="[
                        { value: '1', text: 'Active' },
                        { value: '2', text: 'Inactive' },
                        { value: '3', text: 'Expired' },
                      ]"
                      label="text"
                      :reduce="(option) => option.value"
                      multiple
                      placeholder="All Status"
                      @input="checkSubscriptionStatusSelection"
                      class="input-sm"
                    ></v-select>
                    <small
                      v-if="errors.subscription_status"
                      class="text-danger"
                      >{{ errors.subscription_status }}</small
                    >
                  </div>

                  <label class="col-md-2 control-label">Priority</label>
                  <div class="col-md-4">
                    <input
                      type="number"
                      v-model="formData.priority"
                      id="priority"
                      name="priority"
                      placeholder="Enter Priority (0 or higher)"
                      min="0"
                      class="form-control input-sm"
                      @focus="$event.target.removeAttribute('readonly')"
                      @input="checkPriorityInput"
                      readonly
                    />
                    <small v-if="errors.priority" class="text-danger">{{
                      errors.priority
                    }}</small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-2 control-label">
                    When to Show
                    <span class="mandatory_horizontal">*</span>
                  </label>

                  <div class="col-md-2">
                    <v-select
                      v-model="formData.display_type"
                      :options="[
                        { value: 'always', text: 'Always' },
                        { value: 'schedule', text: 'Schedule' },
                      ]"
                      label="text"
                      :reduce="(option) => option.value"
                      required
                      @input="checkDisplayType"
                      placeholder="Select Display Type"
                      class="input-sm"
                    ></v-select>
                    <small v-if="errors.display_type" class="text-danger">{{
                      errors.display_type
                    }}</small>
                  </div>

                  <div class="form-group">
                    <label class="col-md-2 control-label">
                      Time Period
                      <span class="mandatory_horizontal time_period_1">*</span>
                    </label>

                    <div class="col-md-2">
                      <input
                        v-model="formData.started_at"
                        id="started_at"
                        class="form-control input-sm datePicker"
                        placeholder="Enter Start Time"
                        type="text"
                        @focus="$event.target.removeAttribute('readonly')"
                        @input="errors.started_at && delete errors.started_at"
                        readonly
                        autocomplete="off"
                      />
                      <small v-if="errors.started_at" class="text-danger">{{
                        errors.started_at
                      }}</small>
                    </div>
                    <div class="col-md-1" align="center">To</div>
                    <div class="col-md-2">
                      <input
                        v-model="formData.ended_at"
                        id="ended_at"
                        class="form-control input-sm datePicker"
                        placeholder="Enter End Time"
                        type="text"
                        @focus="$event.target.removeAttribute('readonly')"
                        @input="errors.ended_at && delete errors.ended_at"
                        readonly
                        autocomplete="off"
                      />
                      <small v-if="errors.ended_at" class="text-danger">{{
                        errors.ended_at
                      }}</small>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-2 control-label">Remarks</label>
                  <div class="col-md-4">
                    <textarea
                      v-model="formData.remarks"
                      id="remarks"
                      name="remarks"
                      class="form-control input-sm"
                      @focus="$event.target.removeAttribute('readonly')"
                      readonly
                    ></textarea>
                  </div>
                  <div class="form-group">
                    <label class="col-md-2 control-label"
                      >Days at before expired</label
                    >
                    <div class="col-md-4">
                      <v-select
                        v-model="formData.days_at_before_expired"
                        :options="[
                          { value: '0', text: '0' },
                          { value: '1', text: '1' },
                          { value: '2', text: '2' },
                          { value: '3', text: '3' },
                          { value: '4', text: '4' },
                          { value: '5', text: '5' },
                          { value: '6', text: '6' },
                          { value: '7', text: '7' },
                          { value: '8', text: '8' },
                          { value: '9', text: '9' },
                          { value: '10', text: '10' },
                        ]"
                        label="text"
                        :reduce="(option) => option.value"
                        multiple
                        placeholder="Select nth days for schedule banner"
                        @input="checkDaysAtBeforeExpiredSelection"
                        class="input-sm"
                      ></v-select>
                      <small
                        v-if="errors.days_at_before_expired"
                        class="text-danger"
                        >{{ errors.days_at_before_expired }}</small
                      >
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-3 control-label">Is Active?</label>
                  <div class="col-md-3">
                    <input
                      v-model="formData.status"
                      name="status"
                      value="1"
                      type="checkbox"
                      id="status"
                      @change="errors.status && delete errors.status"
                    />
                    <small v-if="errors.status" class="text-danger">{{
                      errors.status
                    }}</small>
                  </div>
                </div>
              </div>
            </div>

            <input type="hidden" v-model="formData.id" id="id" />

            <div class="col-sm-12 btnCenter" v-show="" style="padding: 10px">
              <div>
                <span
                  class="label label-danger"
                  style="
                    font-size: 15px;
                    padding: 5px 10px;
                    border-radius: 15px;
                  "
                >
                  Total :
                  <span class="" id="total_count">{{}}</span>
                </span>
                <br />
                <span
                  style="font-style: italic; font-size: 11px"
                  class="text-yellow"
                >
                  <i class="fa fa-info-circle"></i> This is approximate count of
                  PINs
                </span>
              </div>
            </div>

            <div class="col-sm-12 btnCenter">
              <input
                type="submit"
                name="submit"
                id="submit"
                value="Save Now"
                class="btn btn-sm btn-submit btn-submit-big"
              />
              <input
                type="button"
                name="submit"
                id="show_total"
                value="Show Total"
                @click="showTotalPins"
                class="btn btn-sm btn-submit btn-submit-big"
              />
            </div>
          </div>
        </form>
      </div>
      <div class="col-md-12" id="countBox">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">
              <i class="fa fa-info-circle"></i>
              Total Users Found
            </h3>
          </div>
          <div class="box-body form-box-body form-horizontal">
            <h4 style="color: #0f9b0f; font-weight: bold">
              <i class="fa fa-user-circle" style="color: #000"></i>
              Total users found for this banner is :
              <span id="totaluserfounds" style="color: red">0</span>
            </h4>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    vSelect,
  },
  name: "AddBanner",
  data() {
    return {
      name: "",
      description: "",
      status: true,
      alert_message: "",
      error_name: false,
      bundles: [],
      rateplans: [],
      prefix: "",
      username: "",
      rate_plan_id: null,
      plan_id: "",
      password: "",
      formData: {
        banner_name: "",
        website_img: "",
        website_img_click_link: "",
        country_selection_type: "",
        specific_countries: [],
        subscription_packages: [],
        days_at_before_expired: [],
        user_type: [],
        subscription_status: [],
        // trial_selection_type: "",
        // trial_type: [],
        display_type: "schedule",
        started_at: "",
        ended_at: "",
        remarks: "",
        priority: null,
        status: 1,
        id: "",
      },
      showEndDate: false,
      trialFilterTypeText: "",
      dateRangeLabel: "",
      selectedCondition: "=",
      countries: [],
      errors: {},
      filteredCountries: [],
      countryFilterTypeText: "",
    };
  },

  created() {
    this.com_user_type_access([0, 1], true);
    var encryptedData = this.$store.getters.getUser;
    var decodedString = this.com_DecryptString(encryptedData);
    this.userData = JSON.parse(decodedString);
    this.prefix = this.userData.reseller4.branding_pin_prefix;
    var id = this.$route.params.id;

    if (id) {
      this.formData.id = id;
    }
    var rootObject = this;
    loader.show();
  },
  mounted() {
    this.loadCountriesDropDown();
    $("#countBox").hide();
    const vm = this;
    $(".datePicker")
      .datetimepicker({
        timepicker: false,
        format: "Y-m-d",
        autoclose: true,
      })
      .on("change", function (e) {
        const inputId = $(this).attr("id");
        if (inputId === "started_at") {
          vm.formData.started_at = $(this).val();
        } else if (inputId === "ended_at") {
          vm.formData.ended_at = $(this).val();
        }
      });

    if (vm.formData.id) {
      // Load existing banner data if editing
      axios
        .post("get-banner-by-id", { id: vm.formData.id })
        .then((response) => {
          console.log("Banner data loaded:", response.data.data);
          let resData = response.data.data;
          vm.formData.banner_name = resData.banner_name;
          vm.formData.website_img = resData.website_img;
          vm.formData.website_img_click_link = resData.website_img_click_link;
          vm.formData.country_selection_type = resData.country_selection_type;
          vm.formData.specific_countries = resData.specific_countries || [];
          vm.formData.subscription_packages =
            resData.subscription_packages || [];
          vm.formData.days_at_before_expired =
            resData.days_at_before_expired || [];
          vm.formData.user_type = resData.user_type || [];
          vm.formData.subscription_status = resData.subscription_status || [];
          vm.formData.display_type = resData.display_type;
          vm.formData.started_at = resData.started_at
            ? new Date(resData.started_at).toISOString().split("T")[0]
            : "";
          vm.formData.ended_at = resData.ended_at
            ? new Date(resData.ended_at).toISOString().split("T")[0]
            : "";
          vm.formData.remarks = resData.remarks || "";
          vm.formData.priority = resData.priority || null;
          vm.formData.status = resData.status;
        })
        .catch((error) => {
          console.error("Error loading banner data:", error);
          loader.hide();
        });
    } else {
      // Initialize formData for new banner
      vm.formData = {
        ...vm.formData,
        started_at: new Date().toISOString().split("T")[0],
        ended_at: new Date(new Date().setDate(new Date().getDate() + 7))
          .toISOString()
          .split("T")[0],
      };
    }
  },
  methods: {
    loadCountriesDropDown() {
      const rootObject = this;
      loader.show();
      axios
        .get("get-country-list")
        .then(function (response) {
          var tmpList = response.data.data;
          tmpList = [...new Set(tmpList)];
          rootObject.countries = tmpList;
          loader.hide();
        })
        .catch(function (error) {
          let alertmessage = "";
          if (error.response && error.response.data) {
            for (let prop in error.response.data) {
              alertmessage += " " + error.response.data[prop];
            }
          } else {
            alertmessage = "An unexpected error occurred.";
          }
          loader.hide();
          rootObject.com_errorHandel(error);
        });
    },

    showTotalPins() {
      if (this.formValidationUser()) {
        return;
      }

      // Map formData to backend expected parameters
      const payload = {
        days_at_before_expired: this.formData.days_at_before_expired,
        subscription_status: this.formData.subscription_status,
        user_type: this.formData.user_type,
        country_selection_type: this.formData.country_selection_type,
        specific_countries: this.formData.specific_countries,
      };

      loader.show();
      axios
        .post("/get-banner-offer-user-count", { ...payload })
        .then((response) => {
          if (response?.data?.result?.toLowerCase() === "success") {
            $("#countBox").show();
            loader.hide();
            $("#totaluserfounds").text(response?.data?.data?.total_pins || 0);
          } else {
            throw new Error("Failed to get user count.");
          }
        })
        .catch((error) => {
          loader.hide();
          alert("Failed to get user count.");
          console.error("Error submitting form:", error);
        });
    },

    formValidationUser() {
      this.errors = {};
      var validationFlag = false;

      // Country selection validation
      if (
        this.formData.country_selection_type &&
        this.formData.country_selection_type == 1 &&
        (!this.formData.specific_countries ||
          this.formData.specific_countries.length === 0)
      ) {
        this.errors.specific_countries = "Please select at least one country";
        validationFlag = true;
      }

      // User type validation (optional array validation)
      if (this.formData.user_type && this.formData.user_type.length > 0) {
        const validUserTypes = ["", "1", "2", "3"];
        const invalidUserTypes = this.formData.user_type.filter(
          (type) => !validUserTypes.includes(type)
        );
        if (invalidUserTypes.length > 0) {
          this.errors.user_type = "Invalid user type selected";
          validationFlag = true;
        }
      }

      // Subscription status validation (optional array validation)
      if (
        this.formData.subscription_status &&
        this.formData.subscription_status.length > 0
      ) {
        const validStatuses = ["1", "2", "3"];
        const invalidStatuses = this.formData.subscription_status.filter(
          (status) => !validStatuses.includes(status)
        );
        if (invalidStatuses.length > 0) {
          this.errors.subscription_status =
            "Invalid subscription status selected";
          validationFlag = true;
        }
      }

      // Days at before expired validation
      if (
        this.formData.days_at_before_expired &&
        this.formData.days_at_before_expired.length > 0
      ) {
        const validDays = [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
        ];
        const invalidDays = this.formData.days_at_before_expired.filter(
          (day) => !validDays.includes(day)
        );
        if (invalidDays.length > 0) {
          this.errors.days_at_before_expired = "Invalid days selection";
          validationFlag = true;
        }
      }

      return validationFlag;
    },

    formValidation() {
      this.errors = {};
      var validationFlag = false;

      // Banner name is required
      if (!this.formData.banner_name) {
        this.errors.banner_name = "Please enter banner name";
        validationFlag = true;
      } else if (this.formData.banner_name.length > 255) {
        this.errors.banner_name = "Banner name must not exceed 255 characters";
        validationFlag = true;
      }

      // Display type is required
      if (!this.formData.display_type) {
        this.errors.display_type = "Please select display type";
        validationFlag = true;
      } else if (!["always", "schedule"].includes(this.formData.display_type)) {
        this.errors.display_type = "Invalid display type selected";
        validationFlag = true;
      }

      // Status is required (convert boolean to string for validation)
      const statusValue =
        this.formData.status === true
          ? "1"
          : this.formData.status === false
          ? "0"
          : this.formData.status;
      if (
        statusValue === null ||
        statusValue === undefined ||
        statusValue === ""
      ) {
        this.errors.status = "Please select status";
        validationFlag = true;
      } else if (!["1", "0"].includes(statusValue.toString())) {
        this.errors.status = "Invalid status value";
        validationFlag = true;
      }

      // Schedule validation - dates are required if display_type is 'schedule'
      if (this.formData.display_type === "schedule") {
        if (!this.formData.started_at) {
          this.errors.started_at = "Please select start date";
          validationFlag = true;
        }
        if (!this.formData.ended_at) {
          this.errors.ended_at = "Please select end date";
          validationFlag = true;
        }

        // Check if start date is before end date
        if (this.formData.started_at && this.formData.ended_at) {
          const startDate = new Date(this.formData.started_at);
          const endDate = new Date(this.formData.ended_at);
          if (startDate >= endDate) {
            this.errors.ended_at = "End date must be after start date";
            validationFlag = true;
          }
        }
      }

      // Country selection validation
      if (
        this.formData.country_selection_type &&
        this.formData.country_selection_type == 1 &&
        (!this.formData.specific_countries ||
          this.formData.specific_countries.length === 0)
      ) {
        this.errors.specific_countries = "Please select at least one country";
        validationFlag = true;
      }

      // Trial selection validation
      if (
        this.formData.trial_selection_type &&
        this.formData.trial_selection_type !== "" &&
        (!this.formData.trial_type || this.formData.trial_type.length === 0)
      ) {
        this.errors.trial_type = "Please select trial type";
        validationFlag = true;
      }

      // Priority validation (if exists)
      if (
        this.formData.priority !== null &&
        this.formData.priority !== undefined &&
        this.formData.priority !== ""
      ) {
        const priorityValue = parseInt(this.formData.priority);
        if (isNaN(priorityValue) || priorityValue < 0) {
          this.errors.priority = "Priority must be a positive number or zero";
          validationFlag = true;
        }
      }

      // User type validation (optional array validation)
      if (this.formData.user_type && this.formData.user_type.length > 0) {
        const validUserTypes = ["", "1", "2", "3"];
        const invalidUserTypes = this.formData.user_type.filter(
          (type) => !validUserTypes.includes(type)
        );
        if (invalidUserTypes.length > 0) {
          this.errors.user_type = "Invalid user type selected";
          validationFlag = true;
        }
      }

      // Subscription status validation (optional array validation)
      if (
        this.formData.subscription_status &&
        this.formData.subscription_status.length > 0
      ) {
        const validStatuses = ["1", "2", "3"];
        const invalidStatuses = this.formData.subscription_status.filter(
          (status) => !validStatuses.includes(status)
        );
        if (invalidStatuses.length > 0) {
          this.errors.subscription_status =
            "Invalid subscription status selected";
          validationFlag = true;
        }
      }
      if (
        this.formData.days_at_before_expired &&
        this.formData.days_at_before_expired.length > 0
      ) {
        const validDays = [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
        ];
        const invalidDays = this.formData.days_at_before_expired.filter(
          (day) => !validDays.includes(day)
        );
        if (invalidDays.length > 0) {
          this.errors.days_at_before_expired = "Invalid days selection";
          validationFlag = true;
        }
      }

      return validationFlag;
    },

    formSubmit(e) {
      e.preventDefault();
      if (this.formValidation()) {
        return;
      }
      var rootObject = this;
      if(!rootObject.formData.status){
        rootObject.formData.status = 0;
      } else {
        rootObject.formData.status = 1; 
      }
      var msg = "Are you sure to send push now?";
      $.confirm({
        title: "Confirm!",
        content: msg,
        buttons: {
          yes: function () {
            loader.show();
            const formElement = rootObject.$refs.myForm;
            const formData = new FormData(formElement);
            axios
              .post("/add-banner", {
                ...rootObject.formData,
              })
              .then(function (response) {
                if (
                  response?.data?.status_code === 201 ||
                  response?.data?.status_code === 200
                ) {
                  console.log("Banner added successfully:", response.data);
                  rootObject.alert_message = response.data.message;
                  loader.hide();
                } else {
                  loader.hide();
                  $.alert("Failed to send push.");
                }
              })
              .catch(function (error) {
                rootObject.com_errorHandel(error);
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += " " + error.response.data[prop];
                }
                loader.hide();
                $.alert(alertmessage);
              });
          },
          no: function () {
            return;
          },
        },
      });
      setTimeout(function () {
        rootObject.alert_message = "";
    
      }, 5000);
    },

    loadRatePlans() {
      var rootObject = this;
      if (this.rate_plan_id) {
        loader.show();

        axios
          .get("get-rates-by-plan-id/" + this.rate_plan_id)
          .then(function (response) {
            rootObject.rateplans = response.data.rates;
            rootObject.plan_id = "";
            loader.hide();
          })
          .catch(function (error) {
            let alertmessage = "";
            for (var prop in error.response.data) {
              alertmessage += " " + error.response.data[prop];
            }
            loader.hide();
            rootObject.com_errorHandel(error);
          });
      } else {
        rootObject.rateplans = [];
        rootObject.plan_id = "";
      }
    },

    // Country selection dependency
    // Country selection dependency
    checkCountrySelect() {
      // Update the filter type text based on selection
      if (this.formData.country_selection_type === "1") {
        this.countryFilterTypeText = "Include";
      } else if (this.formData.country_selection_type === "2") {
        this.countryFilterTypeText = "Exclude";
      } else {
        this.countryFilterTypeText = "";
      }

      // Clear countries if no selection type is chosen
      if (!this.formData.country_selection_type) {
        this.formData.specific_countries = [];
      }

      // Clear country error when selection type changes
      if (this.errors.specific_countries) {
        delete this.errors.specific_countries;
      }
    },

    // Country validation when countries are selected/deselected
    checkCountryTypeRequired() {
      // If country selection type is set but no countries selected, show error
      if (
        this.formData.country_selection_type &&
        this.formData.country_selection_type !== "" &&
        (!this.formData.specific_countries ||
          this.formData.specific_countries.length === 0)
      ) {
        this.errors.specific_countries = "Please select at least one country";
      } else {
        // Clear error if countries are selected
        if (this.errors.specific_countries) {
          delete this.errors.specific_countries;
        }
      }
    },

    // Trial selection dependency
    // checkTrialSelect() {
    //   // Update the filter type text based on selection
    //   if (this.formData.trial_selection_type === "1") {
    //     this.trialFilterTypeText = "Include";
    //   } else if (this.formData.trial_selection_type === "2") {
    //     this.trialFilterTypeText = "Exclude";
    //   } else {
    //     this.trialFilterTypeText = "";
    //   }

    //   // Clear trial types if no selection type is chosen
    //   if (!this.formData.trial_selection_type) {
    //     this.formData.trial_type = [];
    //   }

    //   // Clear trial error when selection type changes
    //   if (this.errors.trial_type) {
    //     delete this.errors.trial_type;
    //   }
    // },

    // Trial type validation when trial types are selected/deselected
    // checkTrialSelectionRequired() {
    //   if (
    //     this.formData.trial_selection_type &&
    //     this.formData.trial_selection_type !== "" &&
    //     (!this.formData.trial_type || this.formData.trial_type.length === 0)
    //   ) {
    //     this.errors.trial_type = "Please select trial type";
    //   } else {
    //     // Clear error if trial types are selected
    //     if (this.errors.trial_type) {
    //       delete this.errors.trial_type;
    //     }
    //   }
    // },

    // Display type dependency
    checkDisplayType() {
      // Clear date fields if display type is not schedule
      if (this.formData.display_type !== "schedule") {
        this.formData.started_at = "";
        this.formData.ended_at = "";
        $(".time_period_1").css("display", "none");
      } else {
        $(".time_period_1").css("display", "inline"); // or 'block' depending on your layout
      }

      // Clear date errors when display type changes
      if (this.errors.started_at) {
        delete this.errors.started_at;
      }
      if (this.errors.ended_at) {
        delete this.errors.ended_at;
      }

      // Clear display type error
      if (this.errors.display_type) {
        delete this.errors.display_type;
      }
    },

    // New function for user type validation
    checkUserTypeSelection() {
      // Clear user type error when selection changes
      if (this.errors.user_type) {
        delete this.errors.user_type;
      }
    },

    // New function for subscription status validation
    checkSubscriptionStatusSelection() {
      // Clear subscription status error when selection changes
      if (this.errors.subscription_status) {
        delete this.errors.subscription_status;
      }
    },

    // New function for days at before expired validation
    checkDaysAtBeforeExpiredSelection() {
      // Clear days at before expired error when selection changes
      if (this.errors.days_at_before_expired) {
        delete this.errors.days_at_before_expired;
      }
    },

    // New function for priority validation
    checkPriorityInput() {
      // Clear priority error when input changes
      if (this.errors.priority) {
        delete this.errors.priority;
      }

      // Real-time validation for priority
      if (
        this.formData.priority !== null &&
        this.formData.priority !== undefined &&
        this.formData.priority !== ""
      ) {
        const priorityValue = parseInt(this.formData.priority);
        if (isNaN(priorityValue) || priorityValue < 0) {
          this.errors.priority = "Priority must be a positive number or zero";
        }
      }
    },
   
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-danger {
  color: red;
}
.inputFlex {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
</style>
